import * as React from 'react';
import s from './IconLink.module.scss';
import linkedin from '../../../../img/linkedin.svg';
import website from '../../../../img/website.svg';
import portfolio from '../../../../img/portfolio.svg';
import resume from '../../../../img/resume.svg';
import Text from '../../Text';

interface Props {
  link: string;
  icon: 'linkedin' | 'website' | 'resume' | 'portfolio';
}

const formatUrl = url => url.replace(/(^\w+:|^)\/\//, '');

export const IconLink = ({ icon, link }: Props) => {
  let iconSrc = resume;
  let title = 'Resumé';

  switch (icon) {
    case 'linkedin':
      iconSrc = linkedin;
      title = 'LinkedIn';
      break;

    case 'website':
      iconSrc = website;
      title = formatUrl(link);
      break;

    case 'portfolio':
      iconSrc = portfolio;
      title = 'Portfolio';
      break;
  }

  return (
    <div className={s.linkWrapper}>
      <a href={link} target="_blank" className={`${s.link}`}>
        <img src={iconSrc} className={s.icon} />
        <Text span>{title}</Text>
      </a>
    </div>
  );
};
